/**
 * DASHBOARD-QUESTIONS-SKELETON.WIDGET
 * Skeleton adapté à la page questions (dashboard-questions.widget.tsx) : quelques
 * "cards" d'axe (illustration + score + libellé) suivies de lignes de thème
 * (caret + score + nom + badge + barre de répartition), pour ne pas remplacer
 * toute la page par un simple spinner pendant le chargement.
 */
import Skeleton, { SkeletonShine } from "@/components/skeleton"

function SkeletonAxisHeader() {
  return (
    <div className="flex items-center" style={{ padding: "24px", gap: 24 }}>
      <Skeleton width={90} height={90} borderRadius={12} />
      <div>
        <Skeleton width={50} height={28} style={{ marginBottom: 10 }} />
        <Skeleton width={220} height={16} />
      </div>
    </div>
  )
}

function SkeletonTopicRow() {
  return (
    <div className="flex items-center" style={{ padding: "14px 24px", gap: 16, borderTop: "1px solid #f0f0f0" }}>
      <Skeleton width={12} height={12} isCircle />
      <Skeleton width={36} height={16} />
      <Skeleton width={170} height={14} />
      <div style={{ flex: 1 }} />
      <Skeleton width={360} height={18} borderRadius={9} />
    </div>
  )
}

export default function DashboardQuestionsSkeletonWidget() {
  return (
    <div>
      {[0, 1].map((axisIndex) => (
        <div key={axisIndex} className="card rel" style={{ marginBottom: 28, overflow: "hidden" }}>
          <SkeletonAxisHeader />
          {[0, 1, 2, 3].map((i) => (
            <SkeletonTopicRow key={i} />
          ))}
          <SkeletonShine />
        </div>
      ))}
    </div>
  )
}
